import { Injectable } from '@angular/core';

@Injectable()
export class DummyService {
  public dummyUsers = [
    {
      datumPromene: 1558801076316,
      korisnik: 'admin',
      ime: 'Marina',
      prezime: 'Milenkovic',
      sektor: 'IT',
      telefon: '011 555 555',
      email: 'm_milenkovic@rts.rs',
      rbr: 1,
      id: '601',
      uloge: [
        {
          rbr: 1,
          nazivUloge: 'Administrator',
        },
        {
          rbr: 2,
          nazivUloge: 'Menadzer',
        },
      ],
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      ime: 'Milica',
      prezime: 'Đuričić Janjić',
      sektor: '',
      telefon: '',
      email: '',
      uloga: 'Menadžer',
      rbr: 2,
      id: '602',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      ime: 'Bata',
      prezime: 'Trišić',
      uloga: 'Administrator',
      sektor: '',
      telefon: '',
      email: '',
      rbr: 3,
      id: '603',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      ime: 'Mira',
      prezime: 'Katanić',
      uloga: 'Ugovaranje, Koordinacija, Fakturisanje',
      sektor: '',
      telefon: '',
      email: '',
      rbr: 4,
      id: '604',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      ime: 'Stana',
      prezime: 'Guzijan',
      uloga: 'Koordinacija, Fakturisanje',
      sektor: '',
      telefon: '',
      email: '',
      rbr: 5,
      id: '605',
    },
  ];

  public dummyCenovnik = [
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: '1',
      brojCenovnika: 1,
      nazivCenovnika: 'Ne znam',
      opis: 'Proba',
      datumPocetkaVazenja: 1558801076316,
      datumKrajaVazenja: 1558801076316,
      isActive: 'Neaktivan',
      datumBrisanja: Date.now(),
      korisnikKojiJeObrisao: 'Marina Milenkovic',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: '2',
      brojCenovnika: 2,
      nazivCenovnika: 'Ne znam',
      opis: 'Proba',
      datumPocetkaVazenja: 1558801076316,
      datumKrajaVazenja: 1558801076316,
      isActive: 'Aktivan',
      datumBrisanja: '',
      korisnikKojiJeObrisao: '',
    },
  ];

  public dummyNacinEmitovanja = [
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 1,
      rbr: 1,
      naziv: 'Ispred',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 2,
      rbr: 2,
      naziv: 'Seča',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 3,
      rbr: 3,
      naziv: 'Posle',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 4,
      rbr: 4,
      naziv: 'Emisija',
      opis: 'Proba',
    },
  ];

  public dummyUcestalostEmitovanja = [
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 1,
      rbr: 1,
      naziv: 'Jednokratno',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 2,
      rbr: 2,
      naziv: 'Dnevno',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 3,
      rbr: 3,
      naziv: 'Nedeljno',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 4,
      rbr: 4,
      naziv: 'Mesečno',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 5,
      rbr: 5,
      naziv: 'Radnim danom',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 6,
      rbr: 6,
      naziv: 'Vikendom',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 7,
      rbr: 7,
      naziv: 'Vikendom',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 8,
      rbr: 8,
      naziv: 'Vikendom',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 9,
      rbr: 9,
      naziv: 'Vikendom',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 10,
      rbr: 10,
      naziv: 'Vikendom',
      opis: 'Proba',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 11,
      rbr: 11,
      naziv: 'Vikendom',
      opis: 'Proba',
    },
  ];

  public dummyCiljneGrupe = [
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 1,
      rbr: 1,
      nazivCiljneGrupe: 'Naziv ciljne grupe neki ne znam',
      opis: 'Neki prozivoljni opis',
      ciljneGrupe: [
        {
          rbr: 1,
          pol: 'muski',
          starostOd: '2',
          starostDo: '15',
        },
        {
          rbr: 2,
          pol: 'zenski',
          starostOd: '15',
          starostDo: '125',
        },
      ],
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      rbr: 2,
      id: 2,
      nazivCiljneGrupe: 'Naziv ciljne grupe neki ne znam',
      opis: 'Neki prozivoljni opis',
      ciljneGrupe: [
        {
          rbr: 1,
          pol: 'muski',
          starostOd: '12',
          starostDo: '42',
        },
        {
          rbr: 2,
          pol: 'zenski',
          starostOd: '12',
          starostDo: '42',
        },
      ],
    },
  ];

  public dummyVrsteZabrane = [
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 1,
      naziv: 'Alkohol (do 18h)',
    },
  ];

  public dummySpotovi = [
    {
      id: 1,
      naziv: 'Prvi spot',
      kupac: 'Prvi kupac',
      datumPrijema: '24-10-2019',
      vrstaZabrane: 'Alkohol (do 18h)',
    },
    {
      id: 2,
      naziv: 'Drugi spot',
      kupac: 'Drugi kupac',
      datumPrijema: '10-09-2019',
      vrstaZabrane: 'Alkohol (do 10h)',
    },
  ];

  public dummyOdrzavanjePrograma = [
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 1,
      sifra: 'OP-12345',
      nazivPrograma: 'Novi program',
      vrstaMedija: 'radio',
      mestoTroska: 'soba',
      mestoTroska2: 'sala1',
      isActive: 'Aktivan',
      datumBrisanja: '',
      korisnikKojiJeObrisao: '',
    },
    {
      korisnik: 'admin',
      datumPromene: 1558801076316,
      id: 1,
      sifra: 'OP-12346',
      nazivPrograma: 'Novi program',
      vrstaMedija: 'radio',
      mestoTroska: 'kancelarija',
      mestoTroska2: 'sala1',
      isActive: 'Neaktivan',
      datumBrisanja: Date.now(),
      korisnikKojiJeObrisao: 'Marina Milenkovic',
    },
  ];

  public dummySifarnikEmisija = [
    {
      id: 1,
      sifra: 'EM12',
      osnovnaCenaEmisije: '50',
      nazivEmisije: 'Zikina sarenica',
      dopunskiNaziv: '',
      program: 'RTS1', // ovde treba da ide  lookup
      vremeEmitovanja: '15:40',
      nacinEmitovanja: 'Televizija',
      datumPocetkaEmitovanja: Date.now(),
      datumKrajaEmitovanja: Date.now(),
      brojDelova: 2,
      ucestalostEmitovanja: 'Jednom nedeljno', // lookup
      stanje: 'Aktivan',
      korisnik: 'Marina Milenkovic',
      datumPromene: Date.now(),
    },
  ];

  public dummyPopustiIUvecanja = [
    {
      id: 1,
      korisnik: 'Marina Milenkovic',
      naziv: 'Letnji popust 2017',
      iznos: '10%',
      opis:
        'Mogu da ga koriste samo drzavne firme ukoliko zele da se reklamiraju',
      izvrsilac: 'Marina Milenkovic',
      datumOd: Date.now(),
      datumDo: Date.now(),
      isActive: 'Neaktivan',
    },
    {
      id: 2,
      korisnik: 'Marina Milenkovic',
      naziv: 'Popust za drzavne firme',
      iznos: '20%',
      opis:
        'Mogu da ga koriste samo drzavne firme ukoliko zele da se reklamiraju',
      izvrsilac: 'Marina Milenkovic',
      datumOd: '',
      datumDo: '',
      isActive: 'Aktivan',
    },
  ];

  public dummyPregledKupaca = [
    {
      korisnik: 'Marina Milenkovic',
      datumPromene: Date.now() - 20000,
      id: 1,
      vrstaKupca: 'klijent',
      nazivKupca: 'Marko Markovic',
      jeAgencija: false,
      jeOglasivac: false,
      grad: 'Novi Sad',
      adresa: 'Bulevar Oslobodjenja bb',
      pibJmbgVat: '11111-22222-33333-44444',
      maticniBroj: 123123123,
      pdv: 50,
      imeKO: 'Milos',
      prezimeKO: 'Milosevic',
      kontaktTelefonKO: '011/1234-123456',
      emailKO: 'milos.milosevic@klijent.rs',
      telefon: '021/500-500',
      saldoDugovanje: 15000,
      saldoPotrazivanje: 250000,
      kontrolnik: 'Dejan Dejanovic',
      imeOZ: '',
      prezimeOZ: '',
      telefonOZ: '',
      emailOZ: '',
      osobaZaduzenaZaKupca: 'Milos Milosevic',
      stanje: 'Aktivan',
    },
  ];

  public dummyRasporedEmisija = [
    {
      korisnik: 'Marina Milenkovic',
      datumPromene: Date.now(),
      id: 1,
      nazivEmisije: 'Zikina sarenica', // lookup
      cenaEmisijePoRasporedu: 50,
      program: 'RTS1',
      datumEmitovanja: Date.now() - 36000,
      vremeEmitovanja: '15:43',
      trajanjeEmisije: '1h 42min',
      raspolozivoVreme: '2h',
    },
  ];

  public dummyUgovori = [
    {
      id: 1,
      sifraUgovora: 555555,
      maticniUgovor: null,
      kupac: 'Ico',
      agencija: 'Neka Agencija',
      tipUgovora: 'Prvi tip',
      datumKreiranja: '12-12-2018',
      datumIsteka: '15-12-2019',
      valuta: 'EUR',
      nacinPlacanja: 'Kartica',
      ugovornaProdaja: '',
      cena: 100,
      korakFakturisanja: null,
      datumFakturisanja: null,
      ciljnaGrupa: 'penzioneri',
      brojDanaPlacanja: 20,
      rabat: '',
      popusti: null,
      brojeviOdluka: 123,
      status: 'kreiran',
      stanje: 'aktivan',
      plasmanac: 'Micko',
      brojAneksa: null,
    },
  ];

  public dummyMediaPlan = [
    {
      id: 1,
      datum: Date.now(),
      vreme: '08:00',
      ost: 325,
    },
    {
      id: 2,
      datum: Date.now(),
      vreme: '18:00',
      ost: 400,
    },
  ];

  public dummyMediaSpotovi = [
    {
      id: 1,
      spot: 'Prvi spot',
      duzina: 5,
      brEm: 1,
      brSp: 3,
    },
    {
      id: 2,
      spot: 'Drugi spot',
      duzina: 20,
      brEm: 4,
      brSp: 7,
    },
  ];

  public dummyMediaEmisije = [
    {
      id: 1,
      emisija: 506,
      naslov: 'Prva emisija',
      vreme: '08:00',
      br: 1,
    },
    {
      id: 2,
      emisija: 456,
      naslov: 'Druga emisija',
      vreme: '08:00',
      br: null,
    },
  ];

  public dummyMediaRezervacije = [
    {
      id: 1,
      CenaPoRasporedu: 10,
      DatumEmitovanja: Date.now(),
      VremeEmitovanja: '08:00',
      Trajanje: 456,
    },
    {
      id: 2,
      CenaPoRasporedu: 50,
      DatumEmitovanja: Date.now(),
      VremeEmitovanja: '21:00',
      Trajanje: 200,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/services/dummy.service.ts